/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InlineResponse20013
 */
export interface InlineResponse20013 {
    /**
     * 
     * @type {boolean}
     * @memberof InlineResponse20013
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20013
     */
    message?: string;
}

export function InlineResponse20013FromJSON(json: any): InlineResponse20013 {
    return InlineResponse20013FromJSONTyped(json, false);
}

export function InlineResponse20013FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20013 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': !exists(json, 'success') ? undefined : json['success'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function InlineResponse20013ToJSON(value?: InlineResponse20013 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
        'message': value.message,
    };
}


